import React, {useState, useEffect} from "react";
import SubHeader from "../../components/SubHeader";
import newJsonData from "../../Data/new.json";
import Layout from "../../components/Layout/Layout";
import {convertJSONintoPreferredSideBarFormat} from "../../utils/sideBarUtils";
import SideMenu from "../../components/SideMenu";
import ApiDetailHeader from "../../components/ApiDetailHeader";
import SchemaContainer from "../../components/SchemaContainer/SchemaContainer";
import MainLayout from "../../components/MethodContainer/MethodContainer";
import MethodContainer from "../../components/MethodContainer";
import ApiDetailSideMenu from "../../components/ApiDetailSideMenu";
import {SideMenuContextProvider} from "../../context/SideMenuContext";
import TryOut from "../../components/TryOut";
import {useMyContext} from "../../context/MyContext";
import dataFile from "../../Data/dataFile.json";
import {extractTitleAndSchemaId} from "../../utils/helpers";
import Loader from "../../components/Loader/Loader";
import * as Constants from "../../constants/Constants";

const ApiDetailsPage = () => {
  const allVersions = dataFile["allVersions"];
  const entitiesConfig = dataFile["entitiesConfig"];
  const {version, showTryOut, setVersion, setEntity} = useMyContext();
  const [data, setData] = useState();
  const [sideMenuData, setSideMenuData] = useState();
  const [groupedByTags, setgroupedByTags] = useState();
  const [loading, setLoading] = useState(true);
  const getData = (()=>{
    setTimeout(() => {
      if (version) {
        const importComponent = async () => {
          const module = await import(`../../Data/${version}.json`);
          setData(module.default);
        };

        importComponent();
      } else {
        setVersion(allVersions[0]);
      }
    }, 50);
  });
  useEffect(()=>{
    setLoading(true);
    getData();
  }, [version]);


  useEffect(()=>{
    setEntity(null);
    if (data) {
      const sortedData ={};
      Object.keys(entitiesConfig).map((each)=>{
        if (data[each]) {
          sortedData[each]=data[each];
        }
      });
      const tempSideMenuData = convertJSONintoPreferredSideBarFormat(sortedData);
      const tempGroupedByTags = tempSideMenuData.reduce((acc, {subEntities, schemas, schemasWithRefs}) => {
        const tagsArray = subEntities?.map(({name, description, tags, id}) => {
          return {
            id,
            name,
            description,
            tags,
            schemas,
            schemasWithRefs,
          };
        });
        if (tagsArray) {
          acc.push([...tagsArray]);
        }
        return acc;
      }, []);
      setSideMenuData(tempSideMenuData);
      setgroupedByTags(tempGroupedByTags);
      setLoading(false);
    }
  }, [data]);
  return (
    <SideMenuContextProvider>
      {(loading) ? (
        <Loader/>
      ) : (
        <>
          <ApiDetailSideMenu menu={sideMenuData} />
          <div className="page-wrapper">
            <div className="content">
              {groupedByTags && groupedByTags?.map((item, index) => {
                const schemas = Object.entries(item?.[0].schemas[0] || {});
                const schemasWithRefs = Object.entries(item?.[0].schemasWithRefs[0] || {});
                return <MethodContainer key={index} groupedByTags={item} schemas={schemas} schemasWithRefs={schemasWithRefs} navIndex={index} component="apiDetail"/>;
              })}

              {/* Separate section for all schemas */}
              <div className="main-section schema-heading" id="schemas">
                <h1 id="internal-mobility-api-schemas">Schemas</h1>
              </div>
              {groupedByTags && groupedByTags?.map((item, index) => {
                const schemas = Object.entries(item?.[0].schemas[0] || {});
                const schemasWithRefs = Object.entries(item?.[0].schemasWithRefs[0] || {});
                return schemas.map((item, index) => {
                  const propertiesTableData = schemasWithRefs[index][1];
                  const {title, uniqueSchemaId}=extractTitleAndSchemaId(item);
                  return <SchemaContainer key={item[0]} id={uniqueSchemaId} title={title} schemas={schemas} propertiesTableData={propertiesTableData} requestBody={item[1]} schemaIndex={item[1]["id"]} />;
                });
              })}
            </div>
          </div>
        </>
      )}
      {showTryOut ? <TryOut /> : null}
    </SideMenuContextProvider>
  );
};

export default ApiDetailsPage;
